<template>
    <!-- Modal Component -->
    <b-modal id="modal_buscadocfiscal"
             ref="modal_buscadocfiscal"
             :title="modal_titulo"
             :ok-title="modal_botao"
             close-title="Fechar"
             v-model="showModalBuscarDocFiscal"
             :ok-disabled=form.errors.any()
             size="lg">
    <b-container fluid class="p-a-0">
        <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
            <div class="row p-t" v-if="vuetableFilterRow">
                <vuetable-filterbar>
                </vuetable-filterbar>
            </div>
            <div class="row loadingDataPosition">

              <div class="loadingData" v-if="loadingDataFiscal"><div class="loadingDataSpinner"><spinner v-if="loadingDataFiscal" text-fg-color="#ffffff" message="Carregando..."></spinner></div></div>
                <vuetable ref="vuetable"
                        api-url="/api/docfiscal"
                        :fields="fields"
                        :css="css"
                        :append-params="moreParams"
                        track-by="docfis_id"
                        pagination-path=""
                        detail-row-component="buscardocfiscal-detalhes"
                        @vuetable:cell-clicked="onDetail"
                        @vuetable:load-error="onError"
                        @vuetable:pagination-data="onPaginationData"
                        @vuetable:loaded="onLoaded"
                      >


                      <template slot="status_uc" slot-scope="props">
                            <span class="badge badge-info" v-if="props.rowData.status.valor==1">{{ props.rowData.status.descr }}</span>
                            <span class="badge badge-warning" v-if="props.rowData.status.valor==2">{{ props.rowData.status.descr }}</span>
                            <span class="badge badge-success" v-if="props.rowData.status.valor==3">{{ props.rowData.status.descr }}[ {{ props.rowData.carga_doc_unidade_carga.length }} ] </span>
                            <span class="badge badge-danger" v-if="props.rowData.status.valor==4">{{ props.rowData.status.descr }}</span>
                      </template>

                      <template slot="actions" slot-scope="props">
                        <div class="custom-actions">
                            <a @click="onDetail(props.rowData, null, null)" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                          </button>
                        </div>
                      </template>
                  </vuetable>
            </div>

            <div class='row m-t'>
                <div class='col-md-12'>
                      <div class="pull-left pagination-detail">
                        <vuetable-pagination-info ref="paginationInfo"
                                                  :css="css.pagination"
                                                  info-class="pull-left"
                        ></vuetable-pagination-info>
                      </div>
                      <div class="pull-right m-a-0">
                        <vuetable-pagination ref="pagination"
                                             :css="css.pagination"
                                             @vuetable-pagination:change-page="onChangePage"
                        ></vuetable-pagination>
                      </div>
                  </div>
              </div>
        </form>
      </b-container>
      <div slot="modal-footer" class="w-100">
             <div class="float-left"><spinner v-if="loading" message="Associando..."></spinner></div>
             <div class="float-right">
               <div class="float-left" v-if="this.errors_array.length>0">
               <b-btn class="badge badge-warning" @click="showPopover = !showPopover" id="popoverButton-sync" v-b-tooltip.hover.left="'Clique aqui para ver os erros encontrados'" variant="warning"><i class="fa fa-exclamation-triangle fa-2x"></i></b-btn>

               <b-popover :show.sync="showPopover" target="popoverButton-sync" title="<strong>Erros Encontrados</strong>" data-html="true" placement="leftbottom">
                 <table class="table" id="mais">
                      <tbody>
                          <tr class="bg-gray-light" style="display: table-row;" v-for="item in this.errors_array">
                             <td>
                               {{ item.erro }}
                             </td>
                         </tr>
                     </tbody>
                 </table>
               </b-popover>
             </div>
             &nbsp;

             <b-btn @click="onVoltar()" variant="secondary">
               Voltar
             </b-btn>
             <b-btn @click="onStore()" variant="primary" :disabled="isDisabled">
               Vincular
             </b-btn>
         </div>
      </div>
  </b-modal>
</template>

<script>
import Vuetable from './Vuetable'
import VuetablePagination from './VuetablePagination'
import VuetablePaginationInfo from './VuetablePaginationInfo'
import BuscarDocFiscalFilterBar from './BuscarDocFiscalFilterBar'
import BuscarDocFiscalDetalhes from './BuscarDocFiscalDetalhes'
import accounting from 'accounting'
import {VMoney} from 'v-money'
import moment from 'moment'

Vue.component('buscardocfiscal-detalhes', BuscarDocFiscalDetalhes);

export default {
    components: {
        VMoney,
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        'vuetable-filterbar': BuscarDocFiscalFilterBar,
    },
    data () {
        return {
          modal_titulo: '',
          modal_botao: '',
          modal_acao: '',
          loading: false,
          isDisabled: false,
          loadingDataFiscal: true,
          showPopover: false,
          showModalBuscarDocFiscal: false,
          docs: [],
          errors_array: [],
          form: new Form({
                    cst: [],
                    chave_cte_multi: '',
                    chave: '',
                }),
          fields: [
            {
                name: '__checkbox',
                titleClass: 'center aligned',
                dataClass: 'center aligned'
            },
            {
              name: 'num_fiscal',
              title: 'Nº Fiscal'
            },
            {
              name: 'serie',
              title: 'Serie'
            },
            {
              name: 'dt_emissao',
              title: 'Data Emissão',
              callback: 'formatDate|DD/MM/YYYY'
            },
            {
              name: 'doc_fiscal_partes_env.emi_cnpj',
              title: 'CNPJ Emitente'
            },
            {
              name: 'doc_fiscal_partes_env.emi_nome',
              title: 'Razão Social Emitente'
            },
            {
              name: 'doc_fiscal_partes_env.des_cnpj',
              title: 'CNPJ Destinatário'
            },
            {
              name: 'doc_fiscal_partes_env.des_nome',
              title: 'Razão Social Destinatário'
            },
            {
              name: '__slot:actions',
              title: 'Ações',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
            }
        ],
        css: {
            tableClass: 'table table-striped',
            loadingClass: 'loading',
            ascendingIcon: 'glyphicon glyphicon-chevron-up',
            descendingIcon: 'glyphicon glyphicon-chevron-down',
            handleIcon: 'glyphicon glyphicon-menu-hamburger',
            detailRowClass: 'vuetable-detail-row',
        },
        moreParams: {}
       }
    },
    directives: {
        money: VMoney,
        aliquota: VMoney,
        qtd: VMoney,
        percentual_reducao_bc: VMoney
    },
    mounted() {
        this.$events.$on('filterModal-set', eventData => this.onFilterSet(eventData));
        this.$events.$on('filterModal-reset', e => this.onFilterReset());
      },
    methods: {
        onPaginationData (paginationData) {
          this.$refs.pagination.setPaginationData(paginationData)
          this.$refs.paginationInfo.setPaginationData(paginationData)
        },
        onChangePage (page) {
          this.$refs.vuetable.changePage(page)
        },
        onFilterSet (data_filter) {
            this.loadingDataFiscal = true;
            this.moreParams = {
                'num_fiscal':  data_filter.num_fiscal,
                'emi_cnpj':  data_filter.emi_cnpj,
                'emi_nome':  data_filter.emi_nome,
                'des_cnpj':  data_filter.des_cnpj,
                'des_nome':  data_filter.des_nome,
                'chave':  data_filter.chave,
                'num_fiscal':  data_filter.num_fiscal,
                'dt_inicio': data_filter.dt_inicio,
                'dt_fim': data_filter.dt_fim
            }
            Vue.nextTick( () => this.$refs.vuetable.reload())
        },
        onFilterReset () {
            this.loadingDataFiscal = true;
            this.moreParams = {}
            Vue.nextTick( () => this.$refs.vuetable.refresh())
            //this.loadingDataFiscal = false;
        },
        onFilterShowHide() {
            if(this.vuetableFilterRow)
            {
                this.$store.commit('setVuetableFilterRow', false);
            }
            else
            {
                this.$store.commit('setVuetableFilterRow', true);
            }
        },
        onLoaded: function () {
            this.dataExport = this.$refs.vuetable.tableData;
            this.loadingDataFiscal = false;
            this.$store.commit('setVuetableFilterButton', false);
        },
        onDetail (data, field, event) {
            this.$refs.vuetable.toggleDetailRow(data.docfis_id);
        },
        formatDate (value, fmt = 'D MMM YYYY HH:mm') {
          return (value == null)
            ? ''
            : moment(value, 'YYYY-MM-DD HH:mm').format(fmt)
        },
        onBuscarDocFiscal (data) {
            this.loadingDataFiscal = true;
            this.modal_titulo = "Buscar Documentos";
            this.modal_botao = "Associar";
            this.modal_acao = "i";
            this.form.reset();
            this.$refs.modal_buscadocfiscal.show();
        },
        onStore() {
            this.docs = null;
            this.docs = [];
            this.$refs.vuetable.selectedTo.forEach((obj)=>{
                this.$refs.vuetable.tableData.forEach((obj2)=>{
                    if(obj2.docfis_id==obj)
                    {
                        this.docs.push({ id: obj2.docfis_id,
                            chave: obj2.chave,
                            num_fiscal: obj2.num_fiscal,
                            serie: obj2.serie,
                            dt_emissao: obj2.dt_emissao,
                            emi_nome: obj2.doc_fiscal_partes_env.emi_nome,
                            emi_cnpj: obj2.doc_fiscal_partes_env.emi_cnpj,
                            des_nome: obj2.doc_fiscal_partes_env.des_nome,
                            des_cnpj: obj2.doc_fiscal_partes_env.des_cnpj,
                            tp_doc: obj2.liv_tp_doc,
                            tp_doc_descr: obj2.liv_tp_doc.label,
                            vlr_total_nfe: obj2.doc_fiscal_vlr_total.vlr_total_nfe
                        })
                    }
                });
            });
            this.$parent.onBuscarDocAssociar(this.docs);
            this.$refs.modal_buscadocfiscal.hide();
        },
        onVoltar() {
            this.$parent.onVoltar();
            this.$refs.modal_buscadocfiscal.hide();
        },
        formatNumberInterno (value) {
            return accounting.formatNumber(value, 2, ',', '.')
        },
        formatNumber (value) {
            return accounting.formatNumber(value, 2, '.', ',')
        },
        formatNumberQtd (value) {
            return accounting.formatNumber(value, 3, '.', ',')
        },
        onError(response) {
            new ReturnApi(response.response, this, true, true, false);
        },
        getPermission(checkPermission) {
            return this.getPermissionFw(checkPermission);
        },
    },
    computed: {
        vuetableFilterRow: {
            get () {
                return this.$store.getters.vuetable.filterRow;
            },
        },
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            }
        }
    }
}
</script>
